import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-market-item',
  templateUrl: './market-item.component.html',
  styleUrls: ['./market-item.component.scss']
})
export class MarketItemComponent implements OnInit {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  @Input() public color: string = 'transparent';
  @HostBinding('class.selected')
  @Input() public selected: boolean = false;
  @Input() public exterior: string = '';
  @Input() public skin: string = '';
  @Input() public weapon: string = '';
  @Input() public box: string = '';
  @Input() public name: string = '';
  @Input() public statuses: string[] = [];
  @Input() public price: number = 0;
  @Input() public recommendedPrice: number = 0;
  @Input() public sellerPrice: number = 0;
  @Input() public id: number = 0;
  @Input() public enabled: boolean = true;
  @Input() public status: string | null = null;
  @Input() public phase: string | null = null;
  @Input() public nextStatusAt: string | null = null;
  @Input() public tradable: boolean = true;
  @Input() public statTrak: boolean = false;

  @HostBinding('attr.style')
  public get valueAsStyle (): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`--rarity-color: ${this.color}`);
  }

  constructor (
    public readonly sanitizer: DomSanitizer,
  ) {
  }


  ngOnInit(): void {
  }


  public getItemExterior (exterior: string): string {
    const dictionary: Record<string, string> = {
      'Factory New': 'FN',
      'Field-Tested': 'FT',
      'Well-Worn': 'WW',
      'Minimal Wear': 'MW',
      'Battle-Scarred': 'BS',
    };
    return dictionary[exterior];
  }

}
